export default __webpack_public_path__ + "static/assets/271fe87512284ea5a1765da524d1cdfb.png";